const PORTAL_GORELO_IO_HOST = "portal.gorelo.io";

export function resolveBaseDomain(): string {
  if (typeof window === "undefined") {
    return "";
  }
  return window.location.hostname.trim();
}

export function isPortalGoreloIoHost(baseDomain = resolveBaseDomain()): boolean {
  return baseDomain.trim().toLowerCase() === PORTAL_GORELO_IO_HOST;
}

/** GetMspCXSetting in PresetLoader is skipped on the default Gorelo portal host. */
export function shouldSkipGetMspCxSetting(): boolean {
  return isPortalGoreloIoHost();
}
